
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

interface ResumeHeaderProps {
  onNewResume: () => void;
  onCreateTest: () => void;
}

const ResumeHeader = ({ onNewResume, onCreateTest }: ResumeHeaderProps) => {
  return (
    <div className="flex justify-between items-center">
      <h2 className="text-xl font-semibold">Your Saved Resumes</h2>
      <div className="flex gap-2">
        <Button size="sm" variant="outline" onClick={onNewResume}>
          <Plus className="mr-2 h-4 w-4" /> New Resume
        </Button>
        <Button size="sm" variant="secondary" onClick={onCreateTest}>
          <Plus className="mr-2 h-4 w-4" /> Create Test Resume
        </Button>
      </div>
    </div>
  );
};

export default ResumeHeader;
